import React from 'react'
import {
  BriefSubmissionStatus,
  BriefPublishingStatus,
} from '@disco/types/types/brief'
import { Badge } from 'components/ds'

type BriefStatusProps = {
  submissionStatus: BriefSubmissionStatus
  publishingStatus: BriefPublishingStatus
}

const BriefStatusBadge = ({
  publishingStatus,
  submissionStatus,
}: BriefStatusProps) => {
  // Show Draft badge for drafts or published briefs with null submission_status
  if (publishingStatus === 'draft' || submissionStatus === null) {
    return (
      <Badge color="gray" variant="soft">
        Draft
      </Badge>
    )
  }

  // For published briefs with a submission_status, show Open or Closed
  if (submissionStatus === 'closed') {
    return (
      <Badge color="red" variant="soft">
        Closed
      </Badge>
    )
  }

  return (
    <Badge color="green" variant="soft">
      Open
    </Badge>
  )
}

export default BriefStatusBadge
